import style from './index.module.scss';

export const CategoryList = ({ categories, categoriesAlias }) => {
    if (categoriesAlias === '') {
        categoriesAlias = 'category';
    }
    return (
        <div className={style.categoryList}>
            {categories &&
                Object.values(categories).map((category, id) => {
                    return (
                        <a className={style.category} href={`/${categoriesAlias}/${category.slug}`} key={id}>
                            <span dangerouslySetInnerHTML={{ __html: category.name }}></span>
                        </a>
                    );
                })}
        </div>
    );
};
